<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <PageTitle title="Результаты тестирования"/>
    </v-col>

    <v-col cols="12" class="py-0">
<!--      <v-btn-->
<!--        small-->
<!--        outlined-->
<!--        rounded-->
<!--        color="primary"-->
<!--        class="white&#45;&#45;text px-4 mr-2"-->
<!--        @click="dialog = true"-->
<!--      >-->
<!--        <v-icon left small>mdi-plus</v-icon>Добавить-->
<!--      </v-btn>-->

      <v-btn
        small
        outlined
        rounded
        :loading="uploadExcel"
        color="primary"
        class="white--text px-4 mr-2"
        @click="chooseExcelFile"
      >
        <input
          type="file"
          class="upload-excel-input"
          accept=".xls, .xlsx"
          ref="excelInput"
          @change="uploadFromExcel"
        />
        <v-icon left small>mdi-table-arrow-down</v-icon>
        Загрузить из EXCEL
      </v-btn>

      <v-btn
        small
        outlined
        rounded
        color="primary"
        :loading="downloadExcel"
        class="white--text px-4 mr-2"
        @click="downloadFromExcel"
      >
        <v-icon left small>mdi-table-arrow-up</v-icon>
        Сохранить в EXCEL
      </v-btn>
    </v-col>

    <v-col cols="12">
      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        filter
        :table-items="applicationParent.list"
        table-height="284"
      >
<!--        <template v-slot:button>-->
<!--          <v-badge-->
<!--            overlap dot-->
<!--            :value="!!checkFilterProperties"-->
<!--          >-->
<!--            <v-btn-->
<!--              v-if="checkRoles"-->
<!--              small rounded outlined-->
<!--              color="primary"-->
<!--              class="white&#45;&#45;text ml-4 filter-btn"-->
<!--              @click="showFilter = !showFilter"-->
<!--            >-->
<!--              <v-icon left small>mdi-filter-outline</v-icon>-->
<!--              <span>{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>-->
<!--            </v-btn>-->
<!--          </v-badge>-->
<!--        </template>-->

        <template v-slot:item.testScore="{ item }">
          <v-col>
            <v-text-field
              full-width
              v-model="item.testScore"
              hide-details
              rounded
              outlined
              dense
              v-mask="'####'"
              @change="saveApplication(item)"
            />
          </v-col>
        </template>

        <template v-slot:item.averageScore="{ item }">
          <v-col>
            <v-text-field
              full-width
              v-model="item.averageScore"
              hide-details
              rounded
              outlined
              dense
              v-mask="'#.##'"
              @change="saveApplication(item)"
            />
          </v-col>
        </template>

        <template v-slot:item.actions="{ item }">
<!--          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="show(item)">-->
<!--            mdi-eye-->
<!--          </v-icon>-->

<!--          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">-->
<!--            mdi-pencil-outline-->
<!--          </v-icon>-->
        </template>

        <transition name="curator-filter">
          <TestResultFilterDialog
            v-show="showFilter"
            @applyFilter="applyFilter"
            @closeFilter="showFilter = false"
            :test-result-filter="testResultFilter"
            width-filter="300"
            top="255"
            right="29"
          />
        </transition>
      </PageTable>
    </v-col>
  </v-row>
</template>

<script>
import { applicationApi, excelApi, vacancyApi } from '@/api'
import PageTitle from '@/components/ui/Title'
import PageTable from '@/components/ui/Table'
import { ApplicationParent, TestResultFilter } from '@/models'
import { mapGetters, mapMutations, mapState } from "vuex"
import download from "@/plugins/download";
import TestResultFilterDialog from "@/components/zvp/testResult/TestResultFilterDialog"

export default {
  name: 'Vacancies',

  components: {
    TestResultFilterDialog,
    PageTitle,
    PageTable,
  },

  created() {
    if (!this.checkRoles) this.$router.push('/')
  },

  data: () => ({
    tableHeaders: [
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'start' },
      { text: 'Статус', value: 'applicationStatus.name', sortable: false, align: 'start' },
      { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start' },
      { text: 'Специальность', value: 'specialityTo.name', sortable: false, align: 'start' },
      { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start' },
      { text: 'Телефон', value: 'phoneNumber', sortable: false, align: 'start' },
      { text: 'e-mail', value: 'email', sortable: false, align: 'start' },
      { text: 'Результаты тестирования', value: 'testScore', sortable: false, align: 'start', width: '180px' },
      { text: 'Средний балл', value: 'averageScore', sortable: false, align: 'start', width: '180px' },
      // { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '180px' }
    ],
    applicationParent: new ApplicationParent(),
    selectedItem: null,

    tableLoading: false,
    cancelLoading: false,
    appointLoading: false,

    uploadExcel: false,
    downloadExcel: false,

    showFilter: false,

    confirmDialog: false,
    dialog: false,

    pageNumber: 0,
    lastPage: false,
  }),

  computed: {
    ...mapState('system', ['dataLoaded']),
    ...mapGetters('user', ['isCurator', 'isAdmin']),
    ...mapGetters('testResultFilter', ['testResultFilter']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },

    checkFilterProperties() {
      for(const item in this.testResultFilter) {
        if (this.testResultFilter[item]?.id) return true
      }

      return false
    },
  },

  methods: {
    ...mapMutations('testResultFilter', ['setTestResultFilter']),

    chooseExcelFile() {
      this.$refs.excelInput.value = ''
      this.$refs.excelInput.dispatchEvent(new MouseEvent('click'))
    },

    async uploadFromExcel() {
      try {
        this.uploadExcel = true
        await excelApi.exportXlsxTestScore(this.$refs.excelInput.files[0])
        await this.applyFilter()
        this.$toastr('success', '', 'Успешно сохранено')
      } catch (e) {
        this.$toastr('error', 'Ошибка загрузки файла')
      } finally {
        this.uploadExcel = false
      }
    },

    async downloadFromExcel() {
      try {
        this.downloadExcel = true
        const data = await excelApi.importXlsxTestScore()
        data && download(data, `Результаты_тестирования.xlsx`)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.downloadExcel = false
      }
    },

    async saveApplication(item) {
      try {
        item.personalData = this.personalDataId
        const data = applicationApi.updateTestScore(item.getForAPI())
        this.applicationParent.update(data)
        return data
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async getApplications() {
      this.tableLoading = true
      try {
        if (!this.lastPage) {
          // const { last, content } = await applicationApi.findAllForTestScoreFilter(this.pageNumber, this.testResultFilter)
          //
          // content?.length && this.applicationParent.build(data)
          // this.lastPage = last
          // this.pageNumber++

          const data = await applicationApi.findAllForTestScore()
          data?.length && this.applicationParent.build(data)
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.tableLoading = false
      }
    },

    async applyFilter(item) {
      this.applicationParent.list = []
      this.lastPage = false
      this.pageNumber = 0
      this.setTestResultFilter(item || new TestResultFilter())
      await this.getApplications()
    },

    show(item) {
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    }
  },

  watch: {
    dataLoaded: {
      immediate: true,
      async handler(value) {
        if (value) {
          await this.getApplications()
        }
      }
    }
  }
}
</script>

<style scoped>

.curator-filter-enter-active {
  transition: opacity .2s;
}

.curator-filter-leave-active {
  transition: opacity .2s;
}

.curator-filter-enter, .curator-filter-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}

.upload-excel-input {
  display: none;
}
</style>
